module.exports = __webpack_public_path__ + "img/banner_2016.4d809114.png";